import { render, staticRenderFns } from "./PublicCourse.vue?vue&type=template&id=a7a0f888"
import script from "./PublicCourse.vue?vue&type=script&lang=js"
export * from "./PublicCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports